import { SubtitleTextSizes } from '../typings';

export const subtitleTextSizes = {
  [SubtitleTextSizes.Smallest]: 3,
  [SubtitleTextSizes.Small]: 4,
  [SubtitleTextSizes.Normal]: 5,
  [SubtitleTextSizes.Large]: 6,
  [SubtitleTextSizes.Largest]: 7,
};

/**
 * Returns the subtitle size based on the window orientation.
 * @param size
 */
export function getOrientationSubtitleTextSize(size: SubtitleTextSizes) {
  const landscape = window.innerWidth > window.innerHeight;
  return `${subtitleTextSizes[size]}${landscape ? 'vh' : 'vw'}`;
}
